<ng-container *ngIf="componentData$ | async as data">
  <ng-container *ngIf="data.uid !== 'CarlisleSalesHompageSplashBannerComponent'">
    <cx-generic-link [url]="data.urlLink" [target]="data.external == 'true' ? '_blank' : null">
      <p *ngIf="data.headline" [innerHTML]="data.headline"></p>
      <cx-media [container]="data.media"></cx-media>
      <p *ngIf="data.content" [innerHTML]="data.content"></p>
    </cx-generic-link>
  </ng-container>
</ng-container>
